module.exports = __webpack_public_path__ + "static/media/bsa.22b93c44.mp4";